import axiosClient from 'utils/axios';
import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';

const endPoint = '/analytics';

const analyticsApi = {
  async getPerformanceStatics(payload) {
    const search = getParamsFormObject(payload);

    const path = endPoint + ENDPOINT.ANALYTICS_PERFORMANCE_STATICS + search;

    const response = await axiosClient.get(path);

    return response.data;
  },
  async getPerformanceOverviews(payload) {
    const search = getParamsFormObject(payload);

    const path = endPoint + ENDPOINT.ANALYTICS_PERFORMANCE_OVERVIEWS + search;

    const response = await axiosClient.get(path);

    return response.data;
  },
  async getPerformanceCharts(payload) {
    const search = getParamsFormObject(payload);

    const path = endPoint + ENDPOINT.ANALYTICS_PERFORMANCE_CHARTS + search;

    const response = await axiosClient.get(path);

    return response.data;
  },
  async getInsightOverview(payload) {
    const search = getParamsFormObject(payload);

    const path = endPoint + ENDPOINT.ANALYTICS_INSIGHTS_OVERVIEW + search;

    const response = await axiosClient.get(path);

    return response.data;
  },
  async getRevenueDistributionOverview(payload) {
    const search = getParamsFormObject(payload);

    const path = endPoint + ENDPOINT.ANALYTICS_REVENUE_DISTRIBUTION_OVERVIEW + search;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getRevenueDistributionChart(payload) {
    const search = getParamsFormObject(payload);

    const path = endPoint + ENDPOINT.ANALYTICS_REVENUE_DISTRIBUTION_CHART + search;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getRevenueDistributionAccountLevels(payload) {
    const search = getParamsFormObject(payload);

    const path = `/analytics/revenue-distribution/account-levels${search}`;

    const response = await axiosClient.get(path);

    return response.data;
  },
};

export default analyticsApi;
